export default __webpack_public_path__ + "static/media/Mercenary's Boots of Pierced Flesh.426746b8.jpg";